import React from 'react';
import { Helmet } from 'react-helmet';
import logo from '../../assets/images/logo.svg';

function SEO({
	title = 'Pay2Mobiles',
	description = 'Pay2Mobiles offers reliable AEPS services, instant DMT, and secure bill payment solutions. Your one-stop digital payment platform.',
	name = 'Webetechies private limited',
	type = 'fintech',
	keywords = 'AEPS, Aadhaar Payment System, DMT services, online bill payment, digital transactions, secure money transfer',
}) {
    const currentPath = window.location.pathname;
console.log(currentPath);
	return (
		<Helmet>
			{/* Standard metadata tags */}
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta name="keywords" content={keywords} />
			<meta property="og:title" content="AEPS Services | Secure Bill Payments & Instant DMT Transfers" />
			<meta
				property="og:description"
				content="Secure AEPS services for cash withdrawals, bill payments, and domestic money transfers. Join the future of digital payments with our trusted platform!"
			/>
		
			{/* Facebook tags */}
			<meta property="og:type" content={type} />
			<meta property="og:title" content="AEPS Services | Secure Bill Payments & Instant DMT Transfers" />
			<meta
				property="og:description"
				content="Secure AEPS services for cash withdrawals, bill payments, and domestic money transfers. Join the future of digital payments with our trusted platform!"
			/>
			<meta property="og:image" content="https://pay2mobiles.com/static/media/logoBlack.d4ca0232.svg" />
		
			{/* Twitter tags */}
			<meta name="twitter:creator" content={name} />
			<meta name="twitter:card" content={type} />
			<meta name="twitter:title" content="AEPS Services | Secure Bill Payments & Instant DMT Transfers" />
			<meta
				name="twitter:description"
				content="Secure AEPS services for cash withdrawals, bill payments, and domestic money transfers. Join the future of digital payments with our trusted platform!"
			/>
		
		</Helmet>
	);
}

export default SEO;
